import React from 'react'
import { Badge } from 'react-bootstrap'
import styled, { css } from 'styled-components'
import { colors } from '../styleGuide'

export interface TagProps extends React.HTMLProps<HTMLDivElement> {
  className?:
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'light'
  | 'dark'
  textColor?: string
  customBackgroundColor?: boolean
}

const tagColors = {
  'non monetory': colors.grey_primary,
  new: colors.green,
  delivered: colors.green,
  processing: colors.teal_primary,
  tracking: colors.cyan_primary,
  returns: colors.red_primary,
  complete: colors.blue_primary,
  'post delivery': colors.indigo_primary,
  cancelled: colors.red_primary,
  refunded: colors.red_primary,
  'partial refunded': colors.red_primary,
  'partial cancelled': colors.red_primary,
  'partial tracking': colors.cyan_primary,
  'partial processing': colors.teal_primary,
  'partial new': colors.green,
  'partial complete': colors.blue_primary,
  'partial returns': colors.red_primary,
  'partial non monetory': colors.grey_primary,
  'partial post delivery': colors.indigo_primary,
  open: colors.orange_primary,
  closed: colors.red_primary,
  'partial ppen': colors.green,
  'partial closed': colors.red_primary,
  refund_partial: colors.grey_primary,
  returned: colors.red_primary,
  exchange_return: colors.grey_primary,
  exchange_partial: colors.grey_primary,
  product: colors.pink_primary,
  shipped: colors.deep_orange_primary,
  'ready to ship': colors.light_blue_accent,
  packaging: colors.green_warm,
  canceled: colors.red_primary,
  failed: colors.red_primary,
  outofstock: colors.red_primary,
  'followup-ip': colors.red_primary,
  'on-hold': colors.red_primary,
  onlinepayment: colors.green,
  prepaid: colors.green,
  pending: colors.orange_primary,
  ready_to_ship: colors.light_blue_accent,
  confirmed: colors.green,
  detain: colors.red_primary,
  'ready-to-ship': colors.light_blue_accent,
  'in-transit': colors.cyan_primary,
  completed: colors.blue_primary,
  partial_paid: colors.green,
  unpaid: colors.red_primary,
  paid: colors.green,
  refund_return: colors.indigo_primary,
  shopify: colors.light_green_primary,
  low: colors.cyan_primary,
  medium: colors.indigo_primary,
  high: colors.red_primary,
  blocker: colors.grey_primary,
  terminated: colors.red_primary,
  overdue: colors.secondaryAccent,
  running: colors.grey_primary,
  todo: colors.grey_primary,
  inprogress: colors.indigo_primary,
  current: colors.green,
  suspended: colors.red_primary,
  trial: colors.indigo_primary,
  engaged: colors.secondaryAccent,
  duplicate: colors.grey_primary,
  active: colors.green,
  series: colors.yellow_primary,
  internal: colors.orange_primary,
  api: colors.green,
  sync: colors.yellow_primary,
  manual: colors.red_primary,
  inactive: colors.red_primary,
  ems: colors.secondaryAccent,
  woocom: colors.green,
  wix: colors.yellow_primary,
  daraz: colors.orange_primary,
  gsheet: colors.indigo_primary,
  TCS: colors.amber_warm,
  Leopard: colors.yellow_secondary,
  'Pakistan Post': colors.red_warm,
  Laugix: colors.orange_primary,
  Forrun: colors.red_secondary,
  Trax: colors.light_green_secondary,
  MNP: colors.orange_warm,
  TCSEnvio: colors.blue_grey_warm,
  Rider: colors.light_blue_primary,
  SmartLane: colors.blue_warm,
  GatePass: colors.cyan_secondary,
  CallCourier: colors.green_secondary,
  DHL: colors.red_primary,
  TEZZ: colors.indigo_warm,
  'Blue-Ex': colors.lime_secondary,
  UPS: colors.amber_primary,
  MoveX: colors.green_warm,
  Swyft: colors.purple_secondary,
  MXC: colors.indigo_warm,
  PostEx: colors.black,
  Daraz: colors.orange_warm,
  BarqRaftar: colors.orange_secondary,
}

const getColor = (children, customBackgroundColor) => {
  if (!customBackgroundColor) {
    if (typeof children === 'string') {
      return tagColors[children.toLowerCase()] || colors.green_warm
    }
  } else {
    return customBackgroundColor
  }
}

export const PixelTag = React.forwardRef<HTMLDivElement, TagProps>(
  (
    {
      className = 'Primary',
      customBackgroundColor = false,
      textColor = 'white',
      children,
      ...rest
    },
    ref
  ) => {
    return (
      <PixelTagStyled>
        <StyledBadge
          data-tag='allowRowEvents'
          className={className}
          bg={className}
          pill
          ref={ref}
          color={`${getColor(children, customBackgroundColor)}`}
        >
          {children}
        </StyledBadge>
      </PixelTagStyled>
    )
  }
)

const PixelTagStyled = styled.div`
  .primary {
    padding: 3px 6px !important;
  }
`

const StyledBadge = styled(Badge)<{ color?: string }>`
  background-color: ${({ color }) => color || colors.green_warm} !important;
`

export default PixelTag
